import {FormLabel, styled} from '@mui/material'
import FormDatePicker from 'components/Control/Form/FormDateInput'
import {useI18n} from 'store/Store'

const CustomPeriodForm = ({formControl, formErrors}) => {
    const {i18n} = useI18n()

    return (
        <Container>
            <InputContainer>
                <FormLabel>{i18n.t('dashboard.from')}</FormLabel>
                <FormDatePicker
                    name="from"
                    control={formControl}
                    rules={{
                        required: true,
                    }}
                    fullWidth
                    errors={formErrors}
                />
            </InputContainer>

            <InputContainer>
                <FormLabel>{i18n.t('dashboard.to')}</FormLabel>
                <FormDatePicker
                    name="to"
                    control={formControl}
                    rules={{
                        required: true,
                    }}
                    fullWidth
                    errors={formErrors}
                />
            </InputContainer>
        </Container>
    )
}

export default CustomPeriodForm

const Container = styled('div')`
    display: flex;
    gap: 24px;
`

const InputContainer = styled('div')`
    display: flex;
    flex-direction: column;
`
